import { useMemo } from 'react'
import { uniq } from 'lodash'

import { useCurrentNode } from 'flow/queryparams'

import lmToConceptDict from 'data/output/lm-to-concept-dict.json'
import edges from 'data/output/concept-deduped-links.json'
import conceptSourceToLinkIndex from 'data/output/concept-source-to-links-index.json'
import conceptTargetToLinkIndex from 'data/output/concept-target-to-links-index.json'

import conceptToCompetencies from 'data/output/concept-to-competencies-dict.json'

export const useCurrentIsConcept = () => {
  const nodeId = useCurrentNode()
  return !lmToConceptDict[nodeId]
}

const useFilteredNodes = () => {
  const nodeId = useCurrentNode()
  const currentIsConcept = useCurrentIsConcept()

  const selectedNodes = useMemo(() => {
    if (currentIsConcept) { // if is a concept
      return uniq(
        [
          nodeId,
          ...(conceptTargetToLinkIndex[nodeId] || []).map((d) => edges[d].source),
          ...(conceptSourceToLinkIndex[nodeId] || []).map((d) => edges[d].target)
        ].reduce((p, c) => {
          return [
            ...p,
            c,
            ...(conceptToCompetencies[c] || [])
          ]
        }, [])
      )
    } else {
      return lmToConceptDict[nodeId]
    }
  }, [nodeId, currentIsConcept])

  return selectedNodes
}

export default useFilteredNodes
